import {
  getGridNumericOperators,
  getGridSingleSelectOperators,
  getGridDateOperators,
  getGridStringOperators,
  GridFilterItem,
} from '@mui/x-data-grid-pro'

export function transformOperator (operator: GridFilterItem['operator']) {
  switch (operator) {
    case '=':
    case 'equals':
      return 'eq' as const
    case '>':
      return 'gt' as const
    case '>=':
      return 'gte' as const
    case 'isAnyOf':
      return 'in' as const
    case 'contains':
      return 'ilike' as const
    case 'onOrBefore':
      return 'lte' as const
    case 'onOrAfter':
      return 'gte' as const
    // return 'like' as const
    // Default to 'eq' for now
    default:
      return 'eq' as const
  }
}

export const filterOperatorsNumeric = getGridNumericOperators().filter(({ value }) =>
  ['=', '>', '>=', 'isAnyOf'].includes(value),
)

export const filterOperatorsString = getGridStringOperators().filter(({ value }) =>
  ['contains', 'equals'].includes(value),
)

export const filterOperatorsSingleSelect = getGridSingleSelectOperators().filter(({ value }) =>
  ['is'].includes(value),
)

export const filterOperatorsDate = getGridDateOperators().filter(({ value }) =>
  ['onOrBefore', 'onOrAfter'].includes(value),
)
